import type { PortalSessionSummary } from "@/core/auth/listPortalSessions";

export interface CreatorWorkspace {
  clientId: string;
  clientName: string | null;
}

/** Union of server-known workspaces and device sessions. The server list
 * wins on labels; sort is stable alpha by display name. */
export function mergeWorkspaces(
  server: CreatorWorkspace[],
  device: Pick<PortalSessionSummary, "clientId" | "clientName" | "role">[]
): CreatorWorkspace[] {
  const byId = new Map<string, CreatorWorkspace>();
  for (const s of device) {
    byId.set(s.clientId, { clientId: s.clientId, clientName: s.clientName });
  }
  for (const s of server) {
    byId.set(s.clientId, s);
  }
  return Array.from(byId.values()).sort((a, b) => {
    const aLabel = (a.clientName || a.clientId).toLowerCase();
    const bLabel = (b.clientName || b.clientId).toLowerCase();
    return aLabel.localeCompare(bLabel);
  });
}
